import React from "react";
import { Box, Container, Typography, styled } from "@mui/material";
import KeyboardDoubleArrowRightSharpIcon from "@mui/icons-material/KeyboardDoubleArrowRightSharp";
import MonetizationOnSharpIcon from "@mui/icons-material/MonetizationOnSharp";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

// Styled Components
const SectionWrapper = styled(Box)(({ theme }) => ({
  background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
  padding: theme.spacing(4, 0),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(6, 0),
  },
}));

const Card = styled(Box)(({ theme, bgColor }) => ({
  backgroundColor: bgColor,
  width: "100%",
  maxWidth: { lg: "70%" },
  padding: theme.spacing(4),
  borderRadius: "10px",
  display: "flex",
  justifyContent: "center",
  position: "relative",
  transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
  "&:hover": {
    transform: "translateY(-10px)",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
    cursor: "pointer",
  },
}));

const CardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
  color: "rgb(0, 209, 132)",
  flexDirection: { xs: "column", md: "row" },
}));

const CardTitle = styled(Typography)(({ theme }) => ({
  fontSize: { xs: "1.27rem", md: "1.5rem" },
  fontWeight: 600,
  textAlign: { xs: "center", md: "left" },
}));

const CardDescription = styled(Typography)(({ theme }) => ({
  fontSize: { xs: "1rem", md: "1.2rem" },
  color: "text.secondary",
  textAlign: { xs: "center", md: "left" },
  marginTop: theme.spacing(1),
}));

const Label = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  fontWeight: 600,
  position: "absolute",
  top: "-1rem",
  backgroundColor: "#fff",
  padding: theme.spacing(1, 2),
  textAlign: "center",
  borderRadius: "10px 0",
  boxShadow: 2,
}));

// Data for cards
const cards = [
  {
    icon: <KeyboardDoubleArrowRightSharpIcon sx={{ fontSize: 40 }} />,
    title: "Browser Redirections = Drop-offs",
    description:
      "Every time a user is sent to an external website, chances are they’ll drop off due to slow loading webpage and many more reasons.",
    bgColor: "rgb(232, 245, 233)",
  },
  {
    icon: <MonetizationOnSharpIcon sx={{ fontSize: 40, mt: { xs: 2, md: 0 } }} />,
    title: "Lost Revenue & Sales",
    description:
      "Potential customers abandon carts because of too many steps, leading to missed opportunities and decreased conversion rates.",
    bgColor: "rgb(255, 243, 224)",
    label: "WHICH CAUSES",
  },
  {
    icon: <TaskAltIcon sx={{ fontSize: 40, mt: { xs: 2, md: 0 } }} />,
    title: "WhatsApp Webviews",
    description:
      "Keep users engaged inside WhatsApp & get more sales, bookings, and signups effortlessly.",
    bgColor: "rgb(252, 228, 236)",
    label: "THE SOLUTION",
  },
];

const TextSection = () => {
  return (
    <SectionWrapper>
      <Container maxWidth="lg" sx={{ textAlign: "center" }}>
        {/* Main Heading */}
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 700,
            color: "#1A202C",
            mb: 1,
            fontSize: { xs: "2rem", md: "3rem" },
          }}
        >
          Why Most Businesses Lose Customers on{" "}
          <Box component="span" sx={{ color: "#00D084" }}>
            WhatsApp
          </Box>
        </Typography>

        {/* Subheading */}
        <Typography
          variant="h5"
          component="h2"
          sx={{
            color: "#00D084",
            mb: 4,
            fontWeight: 550,
            fontSize: { xs: "1.27rem", md: "1.6rem" },
          }}
        >
          (And How Webviews Fix It!)
        </Typography>

        {/* Cards */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 6, md: 8 },
          }}
        >
          {cards.map((card, index) => (
            <Card key={index} bgColor={card.bgColor}>
              {card.label && <Label>{card.label}</Label>}
              <Box>
                <CardHeader>
                  {card.icon}
                  <CardTitle>{card.title}</CardTitle>
                </CardHeader>
                <CardDescription>{card.description}</CardDescription>
              </Box>
            </Card>
          ))}
        </Box>
      </Container>
    </SectionWrapper>
  );
};

export default TextSection;